<template lang="html">
    <div class="flow-duration-date-picker">
        <div class="input year-select">
            <v-select
            :items="yearOptions"
            v-model="yearFrom"
            label="Year from"
            single-line
            ></v-select>
        </div>
        <span>&ndash;</span>
        <div class="input year-select">
            <v-select
            :items="yearOptions"
            v-model="yearTo"
            label="Year to"
            single-line
            ></v-select>
        </div>

        <div class="input month-select">
            <v-select
            :items="monthOptions"
            v-model="month"
            label="Month"
            item-text="label"
            item-value="value"
            single-line
            ></v-select>
        </div>

        <div class="input reset-button">
            <v-btn @click="reset" flat color="primary">Reset Dates</v-btn>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        monthsFilter: {
            required: true,
        },
        yearsFilter: {
            required: true,
        },
        dateRange: {
            required: true,
        },
    },
    data() {
        return {
            monthOptions: [
                { label: 'January', value: 1 },
                { label: 'February', value: 2 },
                { label: 'March', value: 3 },
                { label: 'April', value: 4 },
                { label: 'May', value: 5 },
                { label: 'June', value: 6 },
                { label: 'July', value: 7 },
                { label: 'August', value: 8 },
                { label: 'September', value: 9 },
                { label: 'October', value: 10 },
                { label: 'November', value: 11 },
                { label: 'December', value: 12 },
            ],
        };
    },
    computed: {
        // month selection dropdown
        month: {
            // update the control if only one month is selected: [n, n+1]
            get() {
                const months = this.monthsFilter;
                if (months && months[0] + 1 === months[1]) {
                    return months[0];
                }
                // unset the control if anything else is selected
                return null;
            },
            // change filters to this one month
            set(val) {
                this.$emit('setMonths', [
                    val,
                    val + 1,
                ]);
            },
        },
        // "year from" selection dropdown
        yearFrom: {
            get() {
                const years = this.yearsFilter;
                if (years) {
                    return years[0];
                }
                return null;
            },
            set(val) {
                this.setYear('min', val);
            },
        },
        // "year to" selection dropdown
        yearTo: {
            get() {
                const years = this.yearsFilter;
                if (years) {
                    return years[1];
                }
                return null;
            },
            set(val) {
                this.setYear('max', val);
            },
        },
        yearOptions() {
            const years = [];
            if (this.dateRange) {
                const { min, max } = this.dateRange;
                for (let i = min; i <= max; i += 1) {
                    years.push(i);
                }
            }
            return years;
        },
    },
    methods: {
        /**
         * adjust year values as needed, and emit change event
         * @param {String} field    field name (min or max)
         * @param {Number} newValue new value to change
         */
        setYear(field, newValue) {
            // adjust range if necessary
            let min = this.yearFrom;
            let max = this.yearTo;

            if (field === 'min') {
                min = newValue;
                // if max is unset or < min
                if ((!max) || max < min) {
                    max = this.dateRange.max;
                }
            } else if (field === 'max') {
                max = newValue;
                // if min is unset or > max
                if ((!min) || min > max) {
                    min = this.dateRange.min;
                }
            }
            this.$emit('setYears', [
                min,
                max,
            ]);
        },
        /**
         * emit reset event to parent
         */
        reset() {
            this.$emit('reset');
        },
    },
};
</script>

<style lang="scss">
.flow-duration-date-picker {
    display: flex;
    margin-left: auto;
    max-width: 40rem;
    align-items: center;
    flex: 1 1;

    > .input {
        margin: 0 1rem;
        flex: 1 1 100%;

        &.reset-button {
            flex-grow: 0;
        }

        &:last-child {
            margin-right: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/charts/FDDatePicker.vue